import { Body, Box, Image, motion } from '@hover/blueprint';
import React from 'react';

import type { ScanImagesDetails } from '.';

interface ScanImageContainerProps {
  scanImages: ScanImagesDetails[];
}

const MotionImage = motion(Image);

const ScanImageContainer = ({ scanImages }: ScanImageContainerProps) => (
  <Box
    alignItems="center"
    height="170px"
    justifyContent="center"
    position="relative"
  >
    {scanImages.map((scan, index) => {
      const x = index === 0 ? 0 : -5;
      const y = index === 0 ? 0 : -5;
      const rotate = index === 0 ? 1 : index * -5;
      return (
        <MotionImage
          alt={`scanImage-${index}`}
          animate={{ x, y, rotate }}
          borderRadius={300}
          height="170px"
          key={rotate}
          objectFit="contain"
          position="absolute"
          shadow="default"
          src={scan.imageUrl}
          transition={{ type: 'spring' }}
          zIndex={scanImages.length - index}
        />
      );
    })}
    {scanImages[0].location && (
      <Box
        alignItems="center"
        backgroundColor="neutral.0"
        borderRadius={300}
        bottom={200}
        justifyContent="center"
        maxWidth={750}
        overflow="hidden"
        position="absolute"
        px={200}
        zIndex={scanImages.length ?? 1}
      >
        <Body
          maxWidth={750}
          my={300}
          noOfLines={1}
          textAlign="center"
          width="max-content"
        >
          {scanImages[0].location}
        </Body>
      </Box>
    )}
  </Box>
);

export { ScanImageContainer };
